import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconSkipPreviousTriangle$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconSkipPreviousTriangle extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'fd0c0dfc5f8b9d0052076b7ef9cbdf7d2fd690c0', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a20d948933a87d96f228780eae46249ece7792a7', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '27f123b1a5ee44192e6502a3eea95d430593e121', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m8.9 11.44 8.38 5A.5.5 0 0 0 18 16V6a.49.49 0 0 0-.72-.46l-8.38 5a.5.5 0 0 0 0 .9M5.5 6h1a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-skip-previous-triangle", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-skip-previous-triangle"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-skip-previous-triangle":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconSkipPreviousTriangle$1);
            }
            break;
    } });
}

const CosmosIconSkipPreviousTriangle = CosmosIconSkipPreviousTriangle$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconSkipPreviousTriangle, defineCustomElement };
